import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { catchError, map, Observable, throwError } from "rxjs";
import { AnamnesisModel, ReleaseData } from "../models/anamnese.model";
import { QuestionnaireOrcadentModel } from "libs/questionaire/src/lib/orcadent/models";

@Injectable()
export class AnamnesisService{
	constructor(
		private httpClient: HttpClient,
		@Inject("CONFIG") private config
	) {}


	getReleaseData(treatmentId: string) : Observable<ReleaseData>{
		let params = {
			treatment: treatmentId
		}
		return this.httpClient.get<AnamnesisModel[]>(`${this.config.apiUrl}/anamneses`, {
			params,
			withCredentials: true
		}).pipe(
			map(res => {
				return res.at(0)?.releaseData;
			}),
			catchError(error => {
				return throwError(() => new Error(error.message || 'An unknown error occurred'));
			}));
	}

	getOrcadentQuestionnaireData(treatmentId: string) : Observable<QuestionnaireOrcadentModel>{
		let params = {
			treatment: treatmentId
		}
		return this.httpClient.get<AnamnesisModel[]>(`${this.config.apiUrl}/anamneses`, {
			params,
			withCredentials: true
		}).pipe(
			map(res => {
				const questionnaireData = res.at(0)?.questionnaireData?.orcadent;
				if (!questionnaireData) {
					throw new Error('Questionnaire data is null or undefined');
				}
				return questionnaireData;
			}),
			catchError(error => {
				return throwError(() => new Error(error.message || 'An unknown error occurred'));
			})
		);
	}

	updateReleaseData(treatmentId: string, releaseData: ReleaseData) : Observable<AnamnesisModel>{
		let params = {
			treatment: treatmentId
		}
		let body = {
			releaseData: releaseData
		}
		return this.httpClient.patch<AnamnesisModel>(`${this.config.apiUrl}/anamneses`, body, {
			params,
			withCredentials: true
		})
	}

}
